import Vue from 'vue'
// eslint-disable-next-line eol-last
export default new Vue()



// WEBPACK FOOTER //
// ./src/models/UI/Global.js